import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import KPIComparator from "components/visuals/KPIComparator";

import { useAppSelector } from "store";
import { selectStore } from "modules/customer/insights/portfolio/portfolioSlice";
import { selectors } from "modules/customer/insights/portfolio/catchment/footfall";

const FootfallLevelInOutputArea = () => {
    const selectedStore = useAppSelector(selectStore);
    const footfallLevelInOutputArea = useSelector(state => selectors.footfallLevelInOutputArea(state));
    const { loading, error, value, percentageDifference } = footfallLevelInOutputArea;
    const label = `Footfall level through your ${selectedStore.name} store's output area in the last year vs the comparator`;
    const valueFormatted = value.toFixed(1);

    return (
        <Box width="100%" height="100%" data-cy="footfall-level-in-output-area">
            <KPIComparator loading={loading} error={error} label={label} value={valueFormatted} percentage={percentageDifference} />
        </Box>
    );
};

export default FootfallLevelInOutputArea;
